var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatbots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.201,
    height: 59.201,
    viewBox: "0 0 59.201 59.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.788,35.912H49.923V33.047a4.78,4.78,0,0,0-4.774-4.774H40.375V25.408a.955.955,0,0,0-.955-.955H31.781V22.408a3.819,3.819,0,1,0-1.91,0v2.045H22.233a.955.955,0,0,0-.955.955v2.865H16.5a4.78,4.78,0,0,0-4.774,4.774v2.865H8.865A2.868,2.868,0,0,0,6,38.776V50.235A2.868,2.868,0,0,0,8.865,53.1h2.865v2.865A4.78,4.78,0,0,0,16.5,60.738H45.149a4.78,4.78,0,0,0,4.774-4.774V53.1h2.865a2.868,2.868,0,0,0,2.865-2.865V38.776A2.868,2.868,0,0,0,52.788,35.912ZM28.917,18.724a1.91,1.91,0,1,1,1.91,1.91A1.912,1.912,0,0,1,28.917,18.724ZM8.865,51.19a.956.956,0,0,1-.955-.955V38.776a.956.956,0,0,1,.955-.955h2.865V51.19ZM23.187,26.363H38.465v1.91H23.187Zm24.826,29.6a2.868,2.868,0,0,1-2.865,2.865H16.5a2.868,2.868,0,0,1-2.865-2.865V33.047A2.868,2.868,0,0,1,16.5,30.183H45.149a2.868,2.868,0,0,1,2.865,2.865Zm5.729-5.729a.956.956,0,0,1-.955.955H49.923V37.822h2.865a.956.956,0,0,1,.955.955Z",
    transform: "translate(-1.226 -1.537)",
    fill: "#0080ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.142,46.905H22.955A.955.955,0,0,0,22,47.86v.955a9.549,9.549,0,1,0,19.1,0V47.86A.955.955,0,0,0,40.142,46.905Zm-8.594,9.549a7.648,7.648,0,0,1-7.639-7.639H39.187A7.648,7.648,0,0,1,31.549,56.454Z",
    transform: "translate(-1.948 -2.982)",
    fill: "#0080ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.639,40.724a3.819,3.819,0,1,0-3.819,3.819A3.823,3.823,0,0,0,25.639,40.724Zm-5.729,0a1.91,1.91,0,1,1,1.91,1.91A1.912,1.912,0,0,1,19.91,40.724Z",
    transform: "translate(-1.767 -2.53)",
    fill: "#0080ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.819,36.9a3.819,3.819,0,1,0,3.819,3.819A3.823,3.823,0,0,0,41.819,36.9Zm0,5.729a1.91,1.91,0,1,1,1.91-1.91A1.912,1.912,0,0,1,41.819,42.634Z",
    transform: "translate(-2.67 -2.53)",
    fill: "#0080ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6,21.632a.955.955,0,0,0,1.63-.675V18.092h5.729a2.868,2.868,0,0,0,2.865-2.865V3.77A2.868,2.868,0,0,0,22.962.9H3.865A2.868,2.868,0,0,0,1,3.77V15.228a2.868,2.868,0,0,0,2.865,2.865h8.2ZM2.91,15.228V3.77a.956.956,0,0,1,.955-.955h19.1a.956.956,0,0,1,.955.955V15.228a.956.956,0,0,1-.955.955H16.278a.955.955,0,0,0-.955.955v1.514l-2.189-2.189a.954.954,0,0,0-.675-.28H3.865a.956.956,0,0,1-.955-.955Z",
    transform: "translate(-1 -0.905)",
    fill: "#0080ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.962,4.905h-19.1A2.868,2.868,0,0,0,37,7.77V19.228a2.868,2.868,0,0,0,2.865,2.865h5.729v2.865a.955.955,0,0,0,1.63.675l3.54-3.54h8.2a2.868,2.868,0,0,0,2.865-2.865V7.77A2.868,2.868,0,0,0,58.962,4.905Zm.955,14.323a.956.956,0,0,1-.955.955H50.368a.952.952,0,0,0-.675.28L47.5,22.652V21.138a.955.955,0,0,0-.955-.955H39.865a.956.956,0,0,1-.955-.955V7.77a.956.956,0,0,1,.955-.955h19.1a.956.956,0,0,1,.955.955Z",
    transform: "translate(-2.625 -1.086)",
    fill: "#0080ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5,4.905H22.187v1.91H5Z",
    transform: "translate(-1.181 -1.086)",
    fill: "#0080ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5,12.9H22.187v1.91H5Z",
    transform: "translate(-1.181 -1.447)",
    fill: "#0080ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7,8.9H20.368v1.91H7Z",
    transform: "translate(-1.271 -1.266)",
    fill: "#0080ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41,8.9H58.187v1.91H41Z",
    transform: "translate(-2.806 -1.266)",
    fill: "#0080ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41,16.9H58.187v1.91H41Z",
    transform: "translate(-2.806 -1.627)",
    fill: "#0080ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43,12.9H56.368v1.91H43Z",
    transform: "translate(-2.896 -1.447)",
    fill: "#0080ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbots);
export default __webpack_public_path__ + "static/media/chatbots.73c9e5ad.svg";
export { ForwardRef as ReactComponent };